import React from "react";
import moment from "moment";
import {
  Box,
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  // Checkbox,
  Button,
  Modal,
  Link,
} from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import CardActionArea from "@mui/material/CardActionArea";
import CardActions from "@mui/material/CardActions";
import BlankImg from "../../assets/images/blank.jpg";

const ViewUser = ({ setUserView, userView, deleteSelected }) => {
  return (
    <>
      <Modal
        open={userView}
        onClose={() => setUserView(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="deleteModal" sx={{ padding: "0", overflow: "hidden" }}>
          <Card sx={{}}>
            <CardMedia
              component="img"
              height="140"
              sx={{ objectFit: "contain", padding: "16px 16px 0 16px" }}
              image={
                deleteSelected.current && deleteSelected.current.profile_img
                  ? deleteSelected.current.profile_img
                  : BlankImg
              }
              alt="green iguana"
            />
            <CardContent>
              <TableContainer component={Paper}>
                <Table
                  sx={{ minWidth: 0, width: "100%" }}
                  aria-label="simple table"
                >
                  <TableBody>
                    {/* {deleteSelected.current &&
                      Object.keys(deleteSelected.current)} */}
                    <TableRow
                      key="Mtitle"
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}
                    >
                      <TableCell
                        component="th"
                        scope="row"
                        className="modal_table_head"
                      >
                        Name
                      </TableCell>
                      <TableCell align="left">
                        {" "}
                        {deleteSelected.current &&
                          deleteSelected.current.firstName +
                            " " +
                            deleteSelected.current.lastName}
                      </TableCell>
                    </TableRow>
                    <TableRow
                      key="Mdescription"
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}
                    >
                      <TableCell
                        component="th"
                        scope="row"
                        className="modal_table_head"
                      >
                        Email
                      </TableCell>
                      <TableCell align="left">
                        {" "}
                        {deleteSelected.current && deleteSelected.current.email}
                      </TableCell>
                    </TableRow>

                    <TableRow
                      key="Mclub_name"
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}
                    >
                      <TableCell
                        component="th"
                        scope="row"
                        className="modal_table_head"
                      >
                        Joined At
                      </TableCell>
                      <TableCell align="left">
                        {" "}
                        {deleteSelected.current &&
                          moment(deleteSelected.current.createdAt).format(
                            "MMM D, YYYY"
                          )}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
            <CardActions sx={{ justifyContent: "end" }}>
              <Button
                size="small"
                // color="primary"
                sx={{
                  border: "1px solid #cccfd7",
                  borderRadius: "12px",
                  color: "#1f2a37",
                  fontFamily: "Inter",
                  fontWeight: "500",
                  fontSize: "16px",
                  lineHeight: "150%",
                  backgroundColor: "#ef364e",
                  color: "#fff",
                  "&:hover": {
                    backgroundColor: "#ef364e",
                    color: "#fff",
                  },
                }}
                onClick={() => setUserView(false)}
              >
                Exit
              </Button>
            </CardActions>
          </Card>
        </Box>
      </Modal>
    </>
  );
};

export default ViewUser;
